import { useCallback } from 'react';
import { useStateInRef } from 'seagull';
import { useClientContactModals } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/hooks/useClientContactModals';
import { SAMPLE_CLIENT_ID } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/ClientRecipients/ClientRecipients.utils';
import { useClients } from '~/hooks/reactQuery/queries/useClients';
import { useGetDraftContact } from '../../../../hooks/useGetDraftContact';
import { draftClientId } from '../../../draftClient.utils';
export function useClientSelection(draft, setDraft) {
    const getDraft = useStateInRef(draft);
    const legacyPrimaryContact = useGetDraftContact(draft);
    const selectedClientId = draft.isSample() ? SAMPLE_CLIENT_ID : draftClientId(draft, legacyPrimaryContact);
    const { clients, isLoading, error, refresh } = useClients({
        refreshOnHookMount: true
    });
    const selectClient = useCallback((clientId)=>setDraft(getDraft().setClient(clientId)), [
        setDraft
    ]);
    const { onCreateClient, onEditClient } = useClientContactModals({
        clients,
        selectedClientId,
        onClientCreated: selectClient,
        refreshContacts: async ()=>{}
    });
    const onSelectClient = useCallback((clientId)=>{
        if (clientId !== selectedClientId) selectClient(clientId);
    }, [
        selectedClientId,
        selectClient
    ]);
    const onSelectSample = useCallback(()=>setDraft(getDraft().setSampleContact()), [
        setDraft
    ]);
    const onRetry = useCallback(()=>void refresh({
            throwOnError: false
        }), [
        refresh
    ]);
    return {
        clients,
        isLoading,
        error,
        onRetry,
        selectedClientId,
        onSelectClient,
        onSelectSample,
        onCreateClient,
        onEditClient
    };
}
